/* eslint-disable */
jQuery(document).ready(function($) {
  function initializeJQueryCode() {
    $('.js-modal-trigger').click(function() {
      var target = $(this).data('target');
      $('#' + target).addClass('is-active');
    });

    $('.modal-close, .cancel-modal, .modal-background').click(function() {
      var modal = $(this).closest('.modal');
      modal.removeClass('is-active');
    });

    $('.change-status-publish, .change-status').click(function(e) {
      e.preventDefault();

      var postID = $(this).data('post-id');
      var newStatus = '';

      if ($(this).hasClass('change-status-publish')) {
        newStatus = 'publish';
      } else {  
        newStatus = 'verkocht';
      }

      $.ajax({
        url: '/wp-admin/admin-ajax.php',
        method: 'POST',
        data: {
          action: 'change_status',
          post_id: postID,
          new_status: newStatus
        },
        success: function(response) {
          location.reload();
        },
        error: function(xhr, status, error) {
          console.error(error);
        }
      });
    });
  }

  $('#search-form').on('submit', function(e) {
    e.preventDefault();

    var form = $(this);
    var searchQuery = $('#search-input').val();

    if (searchQuery === '') {
      $('.main-stock').show();
      $('#search-results').empty();
      return;
    }

    // Make the AJAX request
    $.ajax({
      url: form.attr('action'),
      type: 'GET',
      data: form.serialize(),
      beforeSend: function() {
        $(".lds-default").addClass('loading');
      },
      success: function(response) {
        $(".lds-default").removeClass('loading');

        $('#search-results').html(response);
        
        $('.main-stock').hide();

        setTimeout(function() {
          acf.do_action('ready', $('body'));
          acf.do_action('append', $('#search-results'));
        }, 100);

        initializeJQueryCode();
      },
      error: function() {
        $('#search-results').html('<p>Error occurred while searching.</p>');
      },
    });
  });

  initializeJQueryCode();
});
